export const IconComplete = ({
  width = '24',
  height = '24',
  color = '#00B67A',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.5' width='24' height='24' rx='12' fill={color} />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.8402 8.65281C18.0533 8.85657 18.0533 9.18691 17.8402 9.39066L10.5675 16.3472C10.3545 16.5509 10.0091 16.5509 9.79612 16.3472L6.15976 12.8689C5.94675 12.6652 5.94675 12.3348 6.15976 12.1311C6.37277 11.9273 6.71814 11.9273 6.93115 12.1311L10.1818 15.2404L17.0689 8.65281C17.2819 8.44906 17.6272 8.44906 17.8402 8.65281Z'
      fill='#FAFAFC'
    />
  </svg>
);
